import store from '../../store/index'

export default {
  // 车间型号
  className: 'Client',
  fields: [
    {
      name: 'name',
      validators: [
        (val) => val ? null : '客户名称不可为空'
      ]
    },
    {
      name: 'phone',
      validators: [
        (val) => val ? null : '客户电话不可为空'
      ]
    },
    {
      name: 'address',
      validators: [
        (val) => val ? null : '客户地址不可为空'
      ]
    },
    {
      name: 'linkman'
    }
  ],
  search: [
    'name'
  ],
  hooks: {
    beforeInsert ({ data }) {
      data.userid = store.state.user.objectId
    },
    beforeFetch ({ where }) {
      // if (store.state.user && store.state.user.adminRole === 'sale') {
      // where.userid = store.state.user.objectId
      // }
      if (store.state.user && store.state.user.allClient === 'Yes') { } else {
        where.userid = store.state.user.objectId
      }
    }
  },
  action: {
    create: store.state.user && store.state.user.authority.client.create ? {} : false,
    edit: store.state.user && store.state.user.authority.client.edit ? {} : false,
    delete: store.state.user && store.state.user.authority.client.del ? {} : false
  }
}
